import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterOptions } from '@hero/components/molecules/Table/Filter/context';
import { ORGANIZATION_ROLES_LIST, ORGANIZATION_USER_STATUS_LIST } from '@hero/constants';
import { TableSelectFilter } from '@hero/molecules';

import * as S from './style';

function Filter({ globalFilters, placeholder, setGlobalFilters }) {
  const { t } = useTranslation();

  const providerValue = useMemo(() => {
    return {
      inputPlaceholderOnMenu: placeholder,
      hideSearchOnMenu: true
    };
  }, [placeholder]);

  return (
    <S.FilterWrapper>
      {t('filterBy')}:
      <FilterOptions.Provider value={providerValue}>
        <TableSelectFilter
          isMulti
          creatable={false}
          options={ORGANIZATION_ROLES_LIST.map(role => ({
            label: t(role, { count: 1 }),
            value: role
          }))}
          onChange={filters => {
            setGlobalFilters(passValues => ({
              ...passValues,
              filters: {
                ...passValues.filters,
                role: filters
              }
            }));
          }}
          selectedOption={globalFilters?.filters?.role}
          placeholder={t('role')}
        />
        <TableSelectFilter
          isMulti
          options={ORGANIZATION_USER_STATUS_LIST.map(status => ({
            label: t(status),
            value: status
          }))}
          onChange={filters => {
            setGlobalFilters(passValues => ({
              ...passValues,
              filters: {
                ...passValues.filters,
                status: filters
              }
            }));
          }}
          selectedOption={globalFilters?.filters?.status}
          creatable={false}
          placeholder={t('status')}
        />
      </FilterOptions.Provider>
    </S.FilterWrapper>
  );
}

Filter.propTypes = {
  globalFilters: PropTypes.shape({
    filters: PropTypes.shape({
      role: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      status: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    })
  }),
  placeholder: PropTypes.string,
  setGlobalFilters: PropTypes.func
};

export { Filter };
